import { useEffect, useReducer } from "react";
import { useRouter } from "next/router";
import styles from "@/styles/PageTransitionLoading.module.scss";

const initialState = { progress: 0, show: true };
const reducer = (state, action) => {
  switch (action.type) {
    case "increment":
      const newProgres = state.progress + 10;
      return { progress: newProgres, show: true };
    case "update":
      return { progress: action.progress, show: true };
    case "complete":
      return { progress: 0, show: false };
  }
};

export default function PageTransitionLoading() {
  const [state, dispatch] = useReducer(reducer, initialState);
  const router = useRouter();

  useEffect(() => {
    const handleHistoryChangeStart = () => dispatch({ type: "increment" });
    const handleHistoryChangeComplete = () =>
      dispatch({ type: "update", progress: 100 });
    router.events.on("routeChangeStart", handleHistoryChangeStart);
    router.events.on("routeChangeComplete", handleHistoryChangeComplete);
    return () => {
      router.events.off("routeChangeStart", handleHistoryChangeStart);
      router.events.off("routeChangeComplete", handleHistoryChangeComplete);
    };
  }, []);

  useEffect(() => {
    let mounted = true;
    let timeoutId;
    if (mounted) {
      if (state.progress > 0 && state.progress < 90) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => dispatch({ type: "increment" }), 300);
      } else if (state.progress == 100) {
        timeoutId = setTimeout(() => {
          dispatch({ type: "complete" });
        }, 700);
      }
    }
    return () => {
      mounted = false;
      clearTimeout(timeoutId);
    };
  }, [state.progress]);

  return (
    <>
      {state.show && (
        <div className={styles.container}>
          <div className={styles.bar} style={{ width: `${state.progress}%` }} />
        </div>
      )}
    </>
  );
}
